import { TableContainer, Table, TableHead, Paper, TableBody, TableRow, TableCell } from '@mui/material';
import TaskRow from './TaskRow';

const TaskTable = (props) => {
    const {
        taskList,
        reload
    } = props;

    const columns = [
        { id: 'id', label: 'ID' },
        { id: 'timeStampStart', label: 'Время запуска' },
        { id: 'nodeId', label: 'Node id' },
        { id: 'upid', label: 'Upid' },
        { id: 'status', label: 'Статус' },
        { id: 'typeTask', label: 'Тип задачи' },
        { id: 'viewTypeTask', label: 'Расположение задачи' },
        { id: 'action', label: 'Действие' }
    ];

    return (
        <TableContainer id="task_table_container" component={Paper}>
            <Table id="task_manager_table" sx={{ minWidth: 650 }} aria-label="Таблица задач">
                <TableHead id="task_table_head">
                    <TableRow>
                        {columns.map((column) => (
                            <TableCell key={"task_" + column.id} align="left">
                                {column.label}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody id="task_body">
                    {taskList.map((row) => (
                        <TaskRow key={row.id} row={row} columns={columns} reload={reload} />
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export default TaskTable